export var ContractStatus;
(function (ContractStatus) {
    ContractStatus["DRAFT"] = "draft";
    ContractStatus["REVIEW"] = "review";
    ContractStatus["APPROVAL"] = "approval";
    ContractStatus["SIGNING"] = "signing";
    ContractStatus["SIGNING_IN_PROCESS"] = "signing_in_process";
    ContractStatus["COMPLETE"] = "complete";
    ContractStatus["SEALING"] = "sealing";
    ContractStatus["TERMINATED"] = "terminated";
    ContractStatus["VOIDED"] = "voided";
})(ContractStatus || (ContractStatus = {}));
export var ContractSectionsText;
(function (ContractSectionsText) {
    ContractSectionsText["DESCRIPTION"] = "description";
    ContractSectionsText["GENERAL_TERMS"] = "general_terms";
    ContractSectionsText["INCLUSIONS"] = "inclusions_and_exclusions";
    ContractSectionsText["EXCLUSIONS"] = "exclusions";
})(ContractSectionsText || (ContractSectionsText = {}));
export var ContractSectionsObject;
(function (ContractSectionsObject) {
    ContractSectionsObject["DETAILS"] = "details";
    ContractSectionsObject["SCHEDULE_OF_VALUES"] = "schedule_of_values";
    ContractSectionsObject["CONTRACT_ADDENDUMS"] = "contract_addendums";
})(ContractSectionsObject || (ContractSectionsObject = {}));
export var ContractRoles;
(function (ContractRoles) {
    ContractRoles["GENERAL_CONTRACTOR"] = "general_contractor";
    ContractRoles["OWNER"] = "owner";
    ContractRoles["DESIGN_TEAM"] = "design_team";
})(ContractRoles || (ContractRoles = {}));
export var ContractDeltaStatus;
(function (ContractDeltaStatus) {
    ContractDeltaStatus["APPROVED"] = "approved";
    ContractDeltaStatus["REJECTED"] = "rejected";
    ContractDeltaStatus["PENDING"] = "pending";
})(ContractDeltaStatus || (ContractDeltaStatus = {}));
export var ContractDiffTypeEnum;
(function (ContractDiffTypeEnum) {
    ContractDiffTypeEnum["HTML_DIFF"] = "html-diff";
    ContractDiffTypeEnum["JSON_EDIT"] = "json-edit";
})(ContractDiffTypeEnum || (ContractDiffTypeEnum = {}));
export var ContractDatesEnum;
(function (ContractDatesEnum) {
    ContractDatesEnum["EXECUTION_DATE"] = "execution_date";
    ContractDatesEnum["START_DATE"] = "start_date";
    ContractDatesEnum["COMPLETION_DATE"] = "completion_date";
    ContractDatesEnum["NOTICE_TO_PROCEED_DATE"] = "notice_to_proceed_date";
    ContractDatesEnum["ESTIMATED_COMPENSATION_DATE"] = "estimated_compensation_date";
    ContractDatesEnum["SUBSTANTIAL_COMPLETION_DATE"] = "substantial_completion_date";
})(ContractDatesEnum || (ContractDatesEnum = {}));
export var ContractNumbersEnum;
(function (ContractNumbersEnum) {
    ContractNumbersEnum["ARCHITECTURAL_NUMBER"] = "architectural_number";
    ContractNumbersEnum["PUBLIC_WORKS_PROJECT_NUMBER"] = "public_works_project_number";
    ContractNumbersEnum["BID_NUMBER"] = "bid_number";
})(ContractNumbersEnum || (ContractNumbersEnum = {}));
